import { useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'
import HomeHeader from "layouts/homeHeader";
import HomeNavbar from "layouts/homeNavbar";
import BackgroundImage from "assets/images/header.webp";
import styles from "./style.module.scss";
import Input from "components/UI/Input";
import Button from "components/UI/Button";
import SweepIcon from "assets/icons/sweep.svg";
import SentIcon from "assets/icons/sent.svg";
import SettingsIcon from "assets/icons/setting.svg";
import ChatIcon from "assets/icons/chat.svg";
import AnnouncementIcon from "assets/icons/announcement.svg";
import HamburgerIcon from "assets/icons/hamburger.svg";
import { useKeycloak } from "@react-keycloak/web";
import LoaderSpinner from "../../components/UI/LoaderSpinner/LoaderSpinner"; 
import axios from "axios";
import AuthService from "../../services/AuthService";


const Helper = () => {
  const [topic, setTopic] = useState("");
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { keycloak } = useKeycloak();

  const auth = new AuthService(keycloak);

  const sendEmail = async() => {

    setIsLoading(true);
    if (content==="" || topic===""){
      setIsLoading(false);
      toast.error("Lütfen Konu ve Mesaj alanlarını doldurunuz..!", {
        position: toast.POSITION.TOP_RIGHT,
     });
     return;
    }

 
    const data = { mailfrom: keycloak?.tokenParsed?.email, fromName:keycloak?.tokenParsed?.name,content:content,subject:topic };
    
    auth.axios(`/User/SendMailByUser?`, data, null)
    .then((response) => {
        setIsLoading(false);
        if (response.data.success === true) {
          setTopic("");
          setContent("");
          toast.success("Talebiniz iletilmiştir.", {
            position: toast.POSITION.TOP_RIGHT,
         });
        } else {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
         });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
        });

      });
       
  }
  
  return (
    <div className={styles.home}> 
      <div className={styles.left}>
        <HomeNavbar />
      </div>
      <div className={styles.right}>
        <HomeHeader
          personal="#fff"
          hamburgerIcon={HamburgerIcon}
          announcementIcon={AnnouncementIcon}
          chatIcon={ChatIcon}
          settingsIcon={SettingsIcon}
          title="Yardım"
          background={BackgroundImage}
          color={"#fff"}
        />
      <ToastContainer toastStyle={{ backgroundColor: "#f9f9f9" }}/>
        <div className={styles.helper}>
          <div className={styles.newRequest}>
            <div className={styles.caption}>Yeni Destek Talebi Oluştur</div>
            <div className={styles.header}>
              <Input
                label=""
                onChange={(e: any) => setTopic(e.target.value)}
                placeholder="Konu"
                value={topic}
              />
              <textarea
                onChange={(e: any) => setContent(e.target.value)}
                placeholder="Mesajınızı buraya yazın"
                value={content}
              />
              <div className={styles.buttons}>
                <div className={styles.sendButton}>
                  <Button
                    btnType="sendMessage"
                    onClick={() => {
                      sendEmail();
                    }}
                    text="Mesajı Gönder"
                    // width="461px"
                    marginTop="0px"
                    marginRight="18px"
                    icon={SentIcon}
                    color="#fff"
                    marginBottom="20px"
                  />
                </div>
                <div className={styles.sweepButton}>
                  <Button
                    btnType="sweepMessage"
                    onClick={() => {
                      setTopic("");
                      setContent("");
                    }}
                    text="Temizle"
                    // width="461px"
                    marginTop="0px"
                    color="#fff"
                    icon={SweepIcon}
                  />
                </div>
              </div>
            </div>
          </div>
          {isLoading ? <LoaderSpinner /> : ""}
          {/* <div className={styles.oldRequest}>
            <div className={styles.caption}>Önceki Destek Talepleri</div>
            <div className={styles.header}>
              {oldRequestMessages.map((item) => (
                <div className={styles.oldRequests} key={item.id}>
                  <div className={styles.cell}>
                    <div className={styles.icon}></div>
                    <div className={styles.oldRequestContent}>
                      <div className={styles.top}>
                        <div className={styles.title}>{item.title} </div>
                        <div className={styles.date}> {item.date} </div>
                      </div>
                      <div className={styles.bottom}>
                        <div className={styles.content}>{item.content} </div>
                        <div className={styles.solved}> {item.solved} </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Helper;
